import { Style } from '@mui/icons-material'
import { TextField } from '@mui/material'
import { RightArrow } from 'icons/RightArrow'
import styled from 'styled-components'

interface IIsButton {
    isbutton: boolean
}

interface IWarning {
    warning: boolean
}

export const CloseButton = styled.button`
    all:unset;
    background-color: black;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    box-shadow:none;
    gap: 10px;

`
export const CheckBoxDiv = styled.div`
@media(max-width: 844px){
    display:flex;
    gap:12px;
    margin: 16px 16px 16px 0px;
    align-items:center;

}
`
export const TextCheckBoxSpan = styled.span`
@media(max-width: 844px){
    font-family: Gilroy, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%; 

}
`
export const ToProfileButton = styled.button`
@media(min-width:844px){
    height:30px;
    width:168px;
    background-color:#FFFFFF;
    border-radius:8px;
    border:2px solid #149C84;
    cursor:pointer;
    display:flex;
    flex-direction:row;
    margin:0px 0px 0px 20px;
    padding:5px 0px 0px 40px;
    font-size:12px;
    font-weight: 500;
    line-height: 130%; 
    font-family: Gilroy, sans-serif;
    position:relative;
}    
@media(max-width:844px){
    height:30px;
    width:89%;
    justify-content:center;
    background-color:#FFFFFF;
    border-radius:8px;
    border:2px solid #149C84;
    cursor:pointer;
    display:flex;
    position:relative;
    margin:0px 0px 0px 20px;
    flex-direction:row;
    padding:5px 40px 0px 40px;
    font-size:12px;
    font-weight: 500;
    line-height: 130%; 
    font-family: Gilroy, sans-serif;
}

`

export const IconArrowRight = styled(RightArrow)`
   margin-left:7px;
`
export const TextBioSpan = styled.div`
@media(max-width: 844px){
    font-family: Gilroy, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%; 
}
`
export const BiographyName = styled.h2`

        margin:0px 20px 0px 20px;
        font-family: Gilroy, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
    
   
`
export const BiographyBlockDiv = styled.div`
    display: flex;
    flex-direction:row;
    position:relative;
    justify-content: flex-start;
    align-items:center;
`
export const BiographyComp = styled.div`
    position:relative;
    display:flex;
    flex-direction:column;
    margin:76px 0px 0px 3px;
    gap:16px;

`
export const TextFieldWrapper = styled(TextField)`
    width:auto !important;
   height:auto;
   margin:0px 20px 0px 20px !important;
`
export const CharactersCounterWrapper = styled.div<IIsButton>`
    position: absolute;
    display: flex;
    right: 0;
    bottom: ${props => props.isbutton ? '0' : '-20px'}

`
export const Counter = styled.span<IWarning>`
    font-family: Gilroy;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    color: ${props => props.warning ? '#FA5353' : '#1A1A1E'}
`
export const MaxCharacter = styled.span<IWarning>`
    font-family: Gilroy;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    color: ${props => props.warning ? '#FA5353' : '#1A1A1E'}
`
export const WarningPopup = styled.div`
    z-index:3;
    padding: 8px 0px;
    position: absolute;
    left:170px;
    top:-15px;
    width: 289px;
    border-radius: 12px;
    background: #FFF;
    box-shadow: 0px 12px 20px 0px rgba(32, 33, 40, 0.08), 0px 0px 1px 0px rgba(32, 33, 40, 0.12), 0px 0px 3px 0px rgba(0, 0, 0, 0.06);
`
export const WarningAction = styled.p`
    margin: 0;
    padding-top: 8px;
    padding-bottom: 10px;
    padding-right: 12px;
    padding-left: 12px;
    font-family: Gilroy;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    color: #1A1A1E;
    display: flex;
    flex-direction: row;
    gap:12px;
 
`